module.exports = __webpack_public_path__ + "static/media/Jason.5c479761.jpg";